(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ff-floating-header"] && !Shopify.designMode) return;
  try {
    const floatingHeaders = new Map();

  const connectFloatingHeaders = () => {
    for (const [header, cleanup] of floatingHeaders) {
      if (!header.isConnected) {
        cleanup();
        floatingHeaders.delete(header);
      }
    }

    document.querySelectorAll('[data-ff-floating-header]').forEach((header) => {
      if (floatingHeaders.has(header)) return;
      let frame = 0;
      const update = () => {
        frame = 0;
        header.toggleAttribute('data-ff-solid', window.scrollY > 24);
      };
      const onScroll = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('pageshow', update);
      update();
      floatingHeaders.set(header, () => {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('pageshow', update);
        cancelAnimationFrame(frame);
      });
    });
  };

  connectFloatingHeaders();
  document.addEventListener('shopify:section:load', connectFloatingHeaders);
  document.addEventListener('shopify:section:unload', connectFloatingHeaders);
  } catch(e) { console.error(e); }
})();

})();
